import { useState, useEffect } from 'react';

const ONBOARDING_STORAGE_KEY = 'chess-codebreaker-onboarding-completed';

export const useOnboarding = () => {
  const [isOnboardingCompleted, setIsOnboardingCompleted] = useState<boolean>(false);
  const [isOnboardingOpen, setIsOnboardingOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    // Check if onboarding has been completed
    const completed = localStorage.getItem(ONBOARDING_STORAGE_KEY);
    const hasCompleted = completed === 'true';
    
    setIsOnboardingCompleted(hasCompleted);
    
    // If not completed, show onboarding after a brief delay
    if (!hasCompleted) {
      setTimeout(() => {
        setIsOnboardingOpen(true);
        setIsLoading(false);
      }, 500);
    } else {
      setIsLoading(false);
    }
  }, []);

  const completeOnboarding = () => {
    localStorage.setItem(ONBOARDING_STORAGE_KEY, 'true');
    setIsOnboardingCompleted(true);
    setIsOnboardingOpen(false);
  };

  const resetOnboarding = () => {
    localStorage.removeItem(ONBOARDING_STORAGE_KEY);
    setIsOnboardingCompleted(false);
  };

  const openOnboarding = () => {
    setIsOnboardingOpen(true);
  };

  const closeOnboarding = () => {
    setIsOnboardingOpen(false);
  };

  return {
    isOnboardingCompleted,
    isOnboardingOpen,
    isLoading,
    completeOnboarding,
    resetOnboarding,
    openOnboarding,
    closeOnboarding,
  };
};